'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  text-decoration: none;\n'], ['\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  text-decoration: none;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

var Button = (0, _styledComponents2["default"])(_Text2["default"])(_templateObject);
Button.defaultProps = {
  as: 'button',
  display: 'inline-flex',
  fontFamily: 'inherit',
  lineHeight: 'inherit'
};
exports["default"] = Button;
module.exports = exports['default'];